// signupHandler.js

export function validateSignup({
  firstName,
  lastName,
  birthdate,
  email,
  contact,
  password,
  confirmPassword,
  termsAccepted,
}) {
  const errors = {};

  if (!firstName.trim()) errors.firstName = "First name is required.";
  if (!lastName.trim()) errors.lastName = "Last name is required.";
  if (!birthdate.trim()) errors.birthdate = "Birthdate is required.";
  if (!email.trim()) errors.email = "Email is required.";
  if (!contact.trim()) errors.contact = "Contact number is required.";
  if (!password) errors.password = "Password is required.";
  if (!confirmPassword)
    errors.confirmPassword = "Confirm password is required.";
  if (password && confirmPassword && password !== confirmPassword)
    errors.confirmPassword = "Passwords do not match.";
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+])[A-Za-z\d!@#$%^&*()\-_=+]{8,}$/;

  if (password && !passwordRegex.test(password)) {
    errors.password =
      "Password must include uppercase, lowercase, number, and special character.";
  }

  if (!termsAccepted)
    errors.terms = "You must accept the terms and conditions.";

  return errors; // return errors object (empty if no error)
}
